// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PhoneOutgoingIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "PhoneOutgoing/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M17.924 2.617a.995.995 0 0 0-.215-.322l-.004-.004A.997.997 0 0 0 17 2h-4a1 1 0 1 0 0 2h1.586l-3.293 3.293a1 1 0 0 0 1.414 1.414L16 5.414V7a1 1 0 1 0 2 0V3a.997.997 0 0 0-.076-.383Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 3a1 1 0 0 1 1-1h2.153a1 1 0 0 1 .986.836l.74 4.435a1 1 0 0 1-.54 1.06l-1.548.773a11.036 11.036 0 0 0 6.105 6.105l.774-1.548a1 1 0 0 1 1.059-.54l4.436.74a1 1 0 0 1 .835.986V17a1 1 0 0 1-1 1h-2C7.82 18 2 12.18 2 5V3Z"
}));
export default PhoneOutgoingIcon;